import { useTranslation } from 'react-i18next';
import type { SpatialPlanningResultStatistic } from './shared/utils';

interface SpatialPlanningResultProps {
    result: SpatialPlanningResultStatistic;
}

const SpatialPlanningResult = ({ result }: SpatialPlanningResultProps) => {
    const { t } = useTranslation('assessmentResultManagementPage');

    return (
        <div>
            <div className="mx-auto max-w-3xl">
                <div className="mb-8 grid">
                    <div className="grid grid-cols-2 border-b border-b-neutral-300 p-4">
                        <div className="text-base font-semibold text-neutral-900">
                            {t('details.spatialPlanning.columns.correctAnswers')}
                        </div>
                        <div className="justify-self-end text-base text-neutral-500">{result.correctAnswers}</div>
                    </div>
                    <div className="grid grid-cols-2 border-b border-b-neutral-300 p-4">
                        <div className="text-base font-semibold text-neutral-900">
                            {t('details.spatialPlanning.columns.incorrectAnswers')}
                        </div>
                        <div className="justify-self-end text-base text-neutral-500">{result.incorrectAnswers}</div>
                    </div>
                    <div className="grid grid-cols-2 border-b border-b-neutral-300 p-4">
                        <div className="text-base font-semibold text-neutral-900">
                            {t('details.spatialPlanning.columns.accuracy')}
                        </div>
                        <div className="justify-self-end text-base text-neutral-500">{result.accuracy.toFixed(2)}%</div>
                    </div>
                    <div className="grid grid-cols-2 border-b border-b-neutral-300 p-4">
                        <div className="text-base font-semibold text-neutral-900">
                            {t('details.spatialPlanning.columns.averageResponseTime')}
                        </div>
                        <div className="justify-self-end text-base text-neutral-500">
                            {result.averageResponseTimeMs}
                        </div>
                    </div>
                    <div className="grid grid-cols-2 border-b border-b-neutral-300 p-4">
                        <div className="text-base font-semibold text-neutral-900">
                            {t('details.spatialPlanning.columns.fastestResponse')}
                        </div>
                        <div className="justify-self-end text-base text-neutral-500">
                            {result.fastestResponseTimeMs}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpatialPlanningResult;
